import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { onAuthStateChanged, signOut, updateProfile, updatePassword, deleteUser } from "firebase/auth";
import { doc, getDoc, setDoc, updateDoc, collection, getDocs } from "firebase/firestore";
import "./Dashboard.css";

const translations = {
  "English (US)": {
    profile: "My Profile", trips: "My Trips", coupons: "My Coupons", support: "Support", settings: "Settings", logout: "Logout", home: "Home",
    memberSince: "MEMBER SINCE", lastLogin: "LAST LOGIN", totalTrips: "Total Trips", countriesVisited: "Countries Visited",
    editProfile: "✏️ Edit Profile", saveChanges: "Save Changes", cancel: "Cancel", notifications: "Notifications", preferences: "Preferences",
    security: "Security", emailNotify: "Email Notifications", emailNotifyDesc: "Receive booking confirmations via email",
    pushNotify: "Push Notifications", pushNotifyDesc: "Get real-time alerts about your trips",
    promoEmails: "Promotional Emails", promoEmailsDesc: "Receive special offers and travel deals",
    darkMode: "Dark Mode", darkModeDesc: "Switch to dark theme", language: "Language", currency: "Currency",
    changePass: "Change Password", deleteAcc: "Delete Account", noCoupons: "No Coupons Available",
    noCouponsDesc: "We're preparing deals for you. Check back soon!", backToProfile: "Back to Profile",
    needHelp: "Need Help?", supportDesc: "Support is ready to assist you with account and trip issues.",
    liveChat: "Start Live Chat", emailSupport: "Email Support", supportHours: "Support Hours", faq: "Frequently Asked Questions",
    planTitle: "Plan Your Perfect Trip", planDesc: "Your next adventure is just a few clicks away. Let's turn your travel dreams into reality.",
    startPlanning: "Start Planning",
    travelerPrefs: "Traveler Preferences", homeAirport: "Home Airport", travelStyle: "Travel Style", interests: "Interests",
    emergencyName: "Emergency Contact Name", emergencyPhone: "Emergency Phone"
  },
  "Hindi": {
    profile: "मेरी प्रोफाइल", trips: "मेरी यात्राएं", coupons: "मेरे कूपन", support: "सहायता", settings: "सेटिंग्स", logout: "लॉगआउट", home: "होम",
    memberSince: "सदस्यता की तिथि", lastLogin: "पिछला लॉगिन", totalTrips: "कुल यात्राएं", countriesVisited: "देखे गए देश",
    editProfile: "✏️ प्रोफाइल बदलें", saveChanges: "बदलें सहेजें", cancel: "रद्द करें", notifications: "सूचनाएं", preferences: "प्राथमिकताएं",
    security: "सुरक्षा", emailNotify: "ईमेल सूचनाएं", emailNotifyDesc: "ईमेल के माध्यम से बुकिंग पुष्टिकरण प्राप्त करें",
    pushNotify: "पुश सूचनाएं", pushNotifyDesc: "अपनी यात्राओं के बारे में रीयल-टाइम अलर्ट प्राप्त करें",
    promoEmails: "प्रचारात्मक ईमेल", promoEmailsDesc: "विशेष ऑफ़र और यात्रा सौदे प्राप्त करें",
    darkMode: "डार्क मोड", darkModeDesc: "डार्क थीम पर स्विच करें", language: "भाषा", currency: "मुद्रा",
    changePass: "पासवर्ड बदलें", deleteAcc: "खाता हटाएं", noCoupons: "कोई कूपन उपलब्ध नहीं है",
    noCouponsDesc: "हम आपके लिए सौदे तैयार कर रहे हैं। जल्द ही वापस देखें!", backToProfile: "प्रोफ़ाइल पर वापस जाएँ",
    needHelp: "क्या आपको मदद चाहिए?", supportDesc: "सहायता टीम आपके खाते और यात्रा संबंधी समस्याओं में मदद के लिए तैयार है।",
    liveChat: "लाइव चैट शुरू करें", emailSupport: "ईमेल सहायता", supportHours: "सहायता के घंटे", faq: "अक्सर पूछे जाने वाले प्रश्न",
    planTitle: "अपनी बेहतरीन यात्रा की योजना बनाएं", planDesc: "आपका अगला साहसिक कार्य बस कुछ ही क्लिक दूर है। आइए अपने यात्रा के सपनों को हकीकत में बदलें।",
    startPlanning: "योजना बनाना शुरू करें",
    travelerPrefs: "यात्री प्राथमिकताएं", homeAirport: "होम एयरपोर्ट", travelStyle: "यात्रा शैली", interests: "रुचियां",
    emergencyName: "आपातकालीन संपर्क नाम", emergencyPhone: "आपातकालीन फोन"
  },
  "Marathi": {
    profile: "माझी प्रोफाइल", trips: "माझ्या सहली", coupons: "माझे कूपन", support: "मदत", settings: "सेटिंग्ज", logout: "लॉगआउट", home: "होम",
    memberSince: "यापासून सदस्य", lastLogin: "शेवटचे लॉगिन", totalTrips: "एकूण सहली", countriesVisited: "भेट दिलेले देश",
    editProfile: "✏️ प्रोफाइल संपादित करा", saveChanges: "बदल जतन करा", cancel: "रद्द करा", notifications: "सूचना", preferences: "पसंती",
    security: "सुरक्षा", emailNotify: "ईमेल सूचना", emailNotifyDesc: "ईमेलद्वारे बुकिंग पुष्टीकरण प्राप्त करा",
    pushNotify: "पुश सूचना", pushNotifyDesc: "तुमच्या सहलींबद्दल रिअल-टाइम अलर्ट मिळवा",
    promoEmails: "प्रचारात्मक ईमेल", promoEmailsDesc: "विशेष ऑफर आणि प्रवास सौदे प्राप्त करा",
    darkMode: "डार्क मोड", darkModeDesc: "डार्क थीमवर जा", language: "भाषा", currency: "चलन",
    changePass: "पासवर्ड बदला", deleteAcc: "खाते हटवा", noCoupons: "कूपन उपलब्ध नाहीत",
    noCouponsDesc: "आम्ही तुमच्यासाठी सौदे तयार करत आहोत. लवकरच परत तपासा!", backToProfile: "प्रोफाइलवर परत जा",
    needHelp: "मदत हवी आहे?", supportDesc: "खाते आणि सहलीच्या समस्यांसाठी मदत करण्यास सपोर्ट टीम तयार आहे.",
    liveChat: "लाइव्ह चॅट सुरू करा", emailSupport: "ईमेल सपोर्ट", supportHours: "सपोर्टचे तास", faq: "वारंवार विचारले जाणारे प्रश्न",
    planTitle: "तुमच्या सहलीचे नियोजन करा", planDesc: "तुमचे पुढचे साहस फक्त काही क्लिक दूर आहे. चला तुमचे प्रवासाचे स्वप्न साकार करूया.",
    startPlanning: "नियोजन सुरू करा",
    travelerPrefs: "प्रवासी पसंती", homeAirport: "होम एअरपोर्ट", travelStyle: "प्रवास शैली", interests: "आवड",
    emergencyName: "आणीबाणी संपर्क नाव", emergencyPhone: "आणीबाणी फोन"
  }
};

const Icons = { Profile: "👤", Trips: "✈️", Coupons: "🏷️", Support: "🎧", Settings: "⚙️", Logout: "↩️", Home: "🏠", Calendar: "📅", MapPin: "📍" };
const interestOptions = ["Beaches", "Mountains", "Culture", "Food", "Nightlife", "Wildlife", "Shopping", "Adventure"];

export default function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("profile");
  const [stats, setStats] = useState({ totalTrips: 0, countries: 0 });
  const [trips, setTrips] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [settings, setSettings] = useState({
    emailNotify: true,
    pushNotify: true,
    promoEmails: false,
    darkMode: localStorage.getItem("tx_dark") === "1",
    language: "English (US)",
    currency: "USD ($)",
    homeAirport: "",
    travelStyle: "Balanced",
    interests: [],
    emergencyName: "",
    emergencyPhone: ""
  });

  const t = translations[settings.language] || translations["English (US)"];

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) return setUser(null);
      setUser(u);
      setEditName(u.displayName || "");
      const userRef = doc(db, "users", u.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const data = userSnap.data();
        setStats({ totalTrips: data.totalTrips || 0, countries: data.countriesVisited || 0 });
        if (data.prefs) setSettings(prev => ({ ...prev, ...data.prefs }));
      }
      const tripsSnap = await getDocs(collection(db, "users", u.uid, "trips"));
      setTrips(tripsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  const toast = (text) => { setMsg(text); setTimeout(() => setMsg(""), 3500); };

  const toggleSetting = (key) => {
    const newVal = !settings[key];
    setSettings(prev => ({ ...prev, [key]: newVal }));
    if (key === 'darkMode') localStorage.setItem("tx_dark", newVal ? "1" : "0");
  };

  const handleInterestChange = (opt) => {
    setSettings(prev => ({
      ...prev,
      interests: prev.interests.includes(opt) ? prev.interests.filter(i => i !== opt) : [...prev.interests, opt]
    }));
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateProfile(auth.currentUser, { displayName: editName.trim() });
      await updateDoc(doc(db, "users", user.uid), { displayName: editName.trim() });
      setIsEditing(false);
      toast(settings.language === "English (US)" ? "Profile updated." : "प्रोफ़ाइल अपडेट की गई।");
    } catch (err) { toast(err.message); }
    finally { setLoading(false); }
  };

  const handleSaveSettings = async () => {
    setLoading(true);
    try {
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, { prefs: settings }, { merge: true });
      toast("Settings saved.");
    } catch (e) { toast("Error: " + e.message); }
    finally { setLoading(false); }
  };

  const handlePasswordChange = async () => {
    const newPass = prompt(t.changePass + ":");
    if (!newPass) return;
    try { await updatePassword(user, newPass); toast("Success"); }
    catch (e) { toast(e.message); }
  };

  const handleDeleteAccount = async () => {
    if (window.confirm(t.deleteAcc + "?")) {
      try { await deleteUser(user); navigate("/"); }
      catch (e) { toast("Error"); }
    }
  };

  if (!user) return <div className="loading-screen">Loading...</div>;

  return (
    <div className={`dash-container ${settings.darkMode ? "dark-theme" : ""}`}>
      <nav className="dash-nav">
        <div className="nav-content-wrapper">
          <div className="nav-left" onClick={() => navigate("/")}>
            <img src="logo/travxplogo.jpg" alt="Logo" className="brand-logo" />
            <span className="brand-name">TravXplo</span>
          </div>
          <div className="nav-links">
            {["profile", "trips", "coupons", "support", "settings"].map((key) => (
              <button key={key} className={`nav-pill ${activeTab === key ? "active" : ""}`} onClick={() => { setActiveTab(key); setIsEditing(false); }}>
                <span>{Icons[key.charAt(0).toUpperCase() + key.slice(1)]}</span>
                <span className="pill-text">{t[key]}</span>
              </button>
            ))}
            <div className="nav-divider"></div>
            <button className="nav-pill logout-pill" onClick={() => signOut(auth)}>
              <span className="red-text">{Icons.Logout}</span>
              <span className="red-text pill-text">{t.logout}</span>
            </button>
          </div>
        </div>
      </nav>

      <main className="dash-body">
        <div className="content-container">
          <h2 className="page-title">{t[activeTab]}</h2>

          {activeTab === "profile" && (
            <div className="profile-tab-content">
              <div className="profile-main-card">
                {!isEditing ? (
                  <div className="profile-info-flex">
                    <div className="avatar-section">
                      <div className="avatar-container static">
                        {user.photoURL ? <img src={user.photoURL} alt="Profile" className="profile-avatar-img" /> : <div className="profile-avatar-placeholder">{user.displayName ? user.displayName.charAt(0).toUpperCase() : "S"}</div>}
                      </div>
                    </div>
                    <div className="details-section">
                      <div className="details-header"><h3 className="user-name">{user.displayName || "Traveler"}</h3><button className="edit-profile-btn" onClick={() => setIsEditing(true)}>{t.editProfile}</button></div>
                      <p className="user-email">📧 {user.email}</p>
                      <div className="meta-grid">
                        <div className="meta-item"><span className="meta-label">{t.memberSince}</span><span className="meta-value">{new Date(user.metadata.creationTime).toLocaleDateString('en-GB')}</span></div>
                        <div className="meta-item"><span className="meta-label">{t.lastLogin}</span><span className="meta-value">{new Date(user.metadata.lastSignInTime).toLocaleString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <form className="edit-form" onSubmit={handleUpdateProfile}>
                    <h3>{t.editProfile}</h3>
                    <div className="form-group"><label>{t.profile}</label><input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} className="edit-input-field" /></div>
                    <div className="form-actions"><button type="button" className="pill-btn ghost-btn" onClick={() => setIsEditing(false)}>{t.cancel}</button><button type="submit" className="pill-btn primary-gradient-btn" disabled={loading}>{t.saveChanges}</button></div>
                  </form>
                )}
              </div>
              <div className="stats-grid">
                <div className="stat-card"><label className="stat-label">{t.totalTrips}</label><div className="stat-value">{stats.totalTrips}</div></div>
                <div className="stat-card"><label className="stat-label">{t.countriesVisited}</label><div className="stat-value">{stats.countries}</div></div>
              </div>
            </div>
          )}
          
          {/* 2. My Trips Tab - Restored Premium UI */}
          {activeTab === "trips" && (
            <div className="trips-section">
              {trips.length > 0 ? (
                <div className="trips-grid">
                  {trips.map((trip) => (
                    <div key={trip.id} className="trip-card">
                      <div className="trip-info">
                        <h4>{trip.destination}</h4>
                        <p><span>{Icons.Calendar}</span> {trip.date}</p>
                        <p><span>{Icons.MapPin}</span> {trip.location}</p>
                      </div>
                      <div className={`trip-status ${trip.status?.toLowerCase() || 'upcoming'}`}>
                        {trip.status || "Upcoming"}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="plan-journey-section">
                  <div className="journey-content-left">
                    <h2 className="reveal-text">{t.planTitle}</h2>
                    <p className="fade-in-delay">{t.planDesc}</p>
                    {/* inside activeTab === "trips" logic */}
                    <button className="cta-journey-btn" onClick={() => navigate("/plan-your-trip")}>
                      {t.startPlanning} 
                      <span className="arrow-wrapper">
                        <span className="arrow-icon">→</span>
                      </span>
                    </button>
                  </div>
                  
                  <div className="journey-visual-right">
                    <div className="animation-wrapper">
                      <svg viewBox="0 0 400 200" className="journey-svg">
                        {/* Animated Stroke Path */}
                        <path id="travelPath" d="M 20 150 Q 100 50 200 150 T 380 50" fill="none" stroke="#e2e8f0" strokeWidth="2" strokeDasharray="6,6" />
                        <path className="animated-stroke" d="M 20 150 Q 100 50 200 150 T 380 50" fill="none" stroke="#5b99b2" strokeWidth="2" />
                        
                        {/* Checkpoints */}
                        <g className="checkpoint cp-1"><circle cx="20" cy="150" r="4" fill="#5b99b2" /><text x="5" y="140" fontSize="18">📍</text></g>
                        <g className="checkpoint cp-2"><circle cx="200" cy="150" r="4" fill="#5b99b2" /><text x="185" y="140" fontSize="18">🏨</text></g>
                        <g className="checkpoint cp-3"><circle cx="380" cy="50" r="4" fill="#5b99b2" /><text x="365" y="40" fontSize="18">📸</text></g>
                        
                        {/* Animated Dot and Pulse */}
                        <circle r="6" fill="#5b99b2" className="moving-dot">
                          <animateMotion dur="5s" repeatCount="indefinite" path="M 20 150 Q 100 50 200 150 T 380 50" />
                        </circle>
                        <circle r="10" fill="rgba(91, 153, 178, 0.3)" className="pulsing-glow">
                          <animateMotion dur="5s" repeatCount="indefinite" path="M 20 150 Q 100 50 200 150 T 380 50" />
                        </circle>
                      </svg>
                      <div className="cloud c1">☁️</div>
                      <div className="cloud c2">☁️</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {activeTab === "coupons" && (
            <div className="placeholder-view journey-empty-state">
              <div className="animation-container"><span className="placeholder-icon animate-float">🏷️</span></div>
              <h3 className="empty-title">{t.noCoupons}</h3>
              <p className="empty-text">{t.noCouponsDesc}</p>
              <button className="pill-btn ghost-btn mt-20" onClick={() => setActiveTab("profile")}>{t.backToProfile}</button>
            </div>
          )}

          {activeTab === "support" && (
            <div className="support-tab-content">
              <div className="support-hero-card">
                <div className="hero-content">
                  <h3 className="hero-title">{t.needHelp}</h3>
                  <p className="hero-description">{t.supportDesc}</p>
                  <div className="hero-actions">
                    <button className="pill-btn primary-gradient-btn">💬 {t.liveChat}</button>
                    <button className="pill-btn ghost-btn">✉️ {t.emailSupport}</button>
                  </div>
                </div>
                <div className="support-hours-card">
                  <div className="hours-header">🕒 {t.supportHours}</div>
                  <div className="hours-row"><span>Mon - Fri:</span><strong>9AM - 8PM</strong></div>
                  <div className="hours-row"><span>Sat - Sun:</span><strong>10AM - 6PM</strong></div>
                </div>
              </div>

              <div className="contact-methods-grid">
                <div className="contact-card"><div className="contact-icon-circle email-bg">📧</div><h4>Email</h4><p>travxplo@gmail.com</p></div>
                <div className="contact-card"><div className="contact-icon-circle phone-bg">📞</div><h4>Phone</h4><p>+91 92096 79072</p></div>
                <div className="contact-card"><div className="contact-icon-circle chat-bg">💬</div><h4>{t.liveChat}</h4><p><span className="status-indicator available">● Available Now</span></p></div>
              </div>

              <div className="faq-section-wrapper">
                <div className="faq-header">❓ {t.faq}</div>
                <div className="faq-list">
                  <div className="faq-item">
                    <h5>What is TravXplo?</h5>
                    <p>TravXplo is an AI-powered travel and collaboration platform that connects hotels with travel creators to deliver authentic content and impactful digital campaigns.</p>
                  </div>
                  <div className="faq-item">
                    <h5>Who can use TravXplo?</h5>
                    <p>TravXplo is designed for Hotels & resorts looking to increase visibility, travel creators & influencers, and modern travelers exploring curated experiences.</p>
                  </div>
                  <div className="faq-item">
                    <h5>What kind of results can hotels expect?</h5>
                    <p>Hotels can expect high-quality social media content, increased online visibility, authentic promotion through creators, and enhanced brand positioning.</p>
                  </div>
                  <div className="faq-item">
                    <h5>How do you select creators for collaborations?</h5>
                    <p>We carefully select creators based on content quality, audience relevance, engagement rate, and brand alignment.</p>
                  </div>
                  <div className="faq-item">
                    <h5>How can I collaborate as a creator?</h5>
                    <p>Creators can reach out to us via Instagram or through upcoming creator onboarding features on our platform.</p>
                  </div>
                  <div className="faq-item">
                    <h5>Where can I see past collaborations?</h5>
                    <p>You can explore our past collaborations in the “Collaborations” section on our website.</p>
                  </div>
                  <div className="faq-item">
                    <h5>How is collaboration content shared?</h5>
                    <p>All collaboration content is shared via creators’ Instagram profiles and can be accessed through links provided on our website.</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "settings" && (
            <div className="settings-tab-content">
              {/* Notifications Card */}
              <div className="settings-card">
                <div className="settings-header"><span className="icon">🔔</span> {t.notifications}</div>
                <div className="settings-list">
                  <div className="settings-item"><div className="item-info"><h5>{t.emailNotify}</h5><p>{t.emailNotifyDesc}</p></div><label className="toggle-switch"><input type="checkbox" checked={settings.emailNotify} onChange={() => toggleSetting('emailNotify')} /><span className="slider"></span></label></div>
                  <div className="settings-item"><div className="item-info"><h5>{t.pushNotify}</h5><p>{t.pushNotifyDesc}</p></div><label className="toggle-switch"><input type="checkbox" checked={settings.pushNotify} onChange={() => toggleSetting('pushNotify')} /><span className="slider"></span></label></div>
                  <div className="settings-item"><div className="item-info"><h5>{t.promoEmails}</h5><p>{t.promoEmailsDesc}</p></div><label className="toggle-switch"><input type="checkbox" checked={settings.promoEmails} onChange={() => toggleSetting('promoEmails')} /><span className="slider"></span></label></div>
                </div>
              </div>

              {/* Functional Expanded Preferences Card */}
              <div className="settings-card">
                <div className="settings-header"><span className="icon">🌐</span> {t.travelerPrefs}</div>
                <div className="settings-list">
                  <div className="settings-row-grid">
                    <div className="settings-group">
                      <label className="meta-label">{t.homeAirport}</label>
                      <input type="text" className="edit-input-field" placeholder="e.g., BOM (Mumbai)" value={settings.homeAirport} onChange={(e) => setSettings({...settings, homeAirport: e.target.value})} />
                    </div>
                    <div className="settings-group">
                      <label className="meta-label">{t.language}</label>
                      <select className="settings-select" value={settings.language} onChange={(e) => setSettings(prev => ({ ...prev, language: e.target.value }))}>
                        <option value="English (US)">English (US)</option>
                        <option value="Hindi">Hindi</option>
                        <option value="Marathi">Marathi</option>
                      </select>
                    </div>
                    <div className="settings-group">
                      <label className="meta-label">{t.currency}</label>
                      <select className="settings-select" value={settings.currency} onChange={(e) => setSettings(prev => ({ ...prev, currency: e.target.value }))}>
                        <option value="USD ($)">USD ($)</option>
                        <option value="INR (₹)">INR (₹)</option>
                      </select>
                    </div>
                  </div>

                  <div className="settings-group mt-20">
                    <label className="meta-label">{t.travelStyle}</label>
                    <div className="pill-container">
                      {["Relaxed", "Balanced", "Packed"].map(style => (
                        <button key={style} type="button" className={`pref-pill ${settings.travelStyle === style ? 'active' : ''}`} onClick={() => setSettings({...settings, travelStyle: style})}>{style}</button>
                      ))}
                    </div>
                  </div>

                  <div className="settings-group mt-20">
                    <label className="meta-label">{t.interests}</label>
                    <div className="interests-grid">
                      {interestOptions.map(opt => (
                        <label key={opt} className="interest-checkbox">
                          <input type="checkbox" checked={settings.interests.includes(opt)} onChange={() => handleInterestChange(opt)} />
                          <span>{opt}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="settings-row-grid mt-20">
                    <div className="settings-group full-width">
                      <label className="meta-label">{t.emergencyName}</label>
                      <input type="text" className="edit-input-field" placeholder="Person to notify" value={settings.emergencyName} onChange={(e) => setSettings({...settings, emergencyName: e.target.value})} />
                    </div>
                    <div className="settings-group">
                      <label className="meta-label">{t.emergencyPhone}</label>
                      <input type="text" className="edit-input-field" placeholder="+91 98xxxxxx" value={settings.emergencyPhone} onChange={(e) => setSettings({...settings, emergencyPhone: e.target.value})} />
                    </div>
                  </div>
                  
                  <div className="settings-item mt-20">
                    <div className="item-info"><h5>{t.darkMode}</h5><p>{t.darkModeDesc}</p></div>
                    <label className="toggle-switch"><input type="checkbox" checked={settings.darkMode} onChange={() => toggleSetting('darkMode')} /><span className="slider"></span></label>
                  </div>
                </div>
              </div>

              {/* Security Card */}
              <div className="settings-card">
                <div className="settings-header"><span className="icon">🔒</span> {t.security}</div>
                <div className="settings-list">
                  <button className="security-btn" onClick={handlePasswordChange}>{t.changePass}</button>
                  <button className="security-btn" disabled>Two-Factor Authentication (Coming Soon)</button>
                  <button className="security-btn delete" onClick={handleDeleteAccount}>{t.deleteAcc}</button>
                </div>
              </div>

              <div className="settings-footer">
                <button className="pill-btn primary-gradient-btn save-settings" onClick={handleSaveSettings} disabled={loading}>{loading ? "..." : t.saveChanges}</button>
              </div>
            </div>
          )}
        </div>
      </main>

      {msg && <div className="toast">{msg}</div>}
      <footer className="dash-footer"><p>© 2026 TravXplo. Your journey begins here.</p></footer>
    </div>
  );
}
